module.exports = __webpack_public_path__ + "img/failed.ee69dcca.png";